module.exports = __webpack_public_path__ + "za.591d4eda2c7928b882db.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/za.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/za.svg
// module chunks = styles